import Logger from '@/modules/core/app/helpers/Logger';

export class ServiceWorkerService {
  init() {
    try {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .register('/sw.js', { scope: '/' })
          .then((registration) => {
            // registration worked
            Logger.log('Registration succeeded.');
            registration.unregister().then((boolean) => {
              // if boolean = true, unregister is successful
              Logger.log('Unregister succeeded:', boolean);
            });
          })
          .catch((error) => {
            // registration failed
            Logger.info(error.message);
          });
      }
    } catch (error) {
      Logger.info(error.message);
    }
  }
}

export default new ServiceWorkerService();
